type Options = {
  rounding?: "floor" | "none";
};

const MINUTES_PER_HOUR = 60;

export default function minutesToHours(
  minutes: number,
  { rounding = "floor" }: Options = {},
) {
  const value = minutes / MINUTES_PER_HOUR;
  return {
    floor: () => Math.floor(value),
    none: () => value,
  }[rounding]();
}
